import React from 'react';

import { Touchable } from '@skippay/core/@types/touchable';
import Link from '@skippay/core/components/Link';
import { be, bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'NavigationList';

interface Props {
	onRow?: boolean;
	links: Array<{
		ariaLabel?: string;
		text: JSX.Element;
		url?: Touchable['to'];
	}>;
	verticalCenter?: boolean;
}

const NavigationList = (props: Props): JSX.Element => {
	const { links, onRow, verticalCenter } = props;

	return (
		<nav>
			<ul className={bm(MODULE_NAME, { onRow, verticalCenter })}>
				{links.map((link, idx) => (
					// eslint-disable-next-line react/no-array-index-key
					<li key={String(idx)} className={be(MODULE_NAME, 'item')}>
						<Link
							aria-label={link.ariaLabel}
							variant='inverted'
							textDecoration={['none', 'underline']}
							testId="navigation"
							analyticsId="navigation"
							to={link.url}
						>
							{link.text}
						</Link>
					</li>
				))}
			</ul>
		</nav>
	);
};

export default NavigationList;
